import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button, Form, Card, Row, Col, Dropdown, Spinner, Image } from "react-bootstrap";
import {
  Formik,
  Field,
  Form as FormikForm,
  ErrorMessage,
  FieldArray,
} from "formik";
import * as Yup from "yup";
import Pagination from "../components/Pagination";
import toast from "react-hot-toast";
import {
  getTEMPLATES,
  addTEMPLATES,
  updateTEMPLATES,
  deleteTEMPLATES,
} from "../../services/UserServices/UserService";
import { uploadFileToS3 } from "../../utils/bucket";
import PageContentLoader from "../components/TableLoader";
import ConfirmDeleteModal from "../Modals/ConfirmDelete";
import { debounce } from "lodash";
import PageTitle from "../layouts/PageTitle";
const Template = () => {
  const [templates, setTemplates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [loader, setLoader] = useState(false)
  const itemsPerPage = 10;

  const [totalItems, setTotalItems] = useState(0);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [search, setSearch] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewImg, setPreviewImg] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const validationSchema = Yup.object().shape({
    event: Yup.string().required("Please select an event"),
    html: Yup.string().required("HTML is required"),
    name: Yup.string().required("Template name is required"),
    editableKeys: Yup.array().of(
      Yup.object().shape({
        key: Yup.string().required("Key is required"),
        value: Yup.string().required("Value is required"),

        maxLength: Yup.number()
          .typeError("Max length must be a number")
          .required("Max length is required")
          .positive("Must be positive")
          .integer("Must be integer"),
      })
    ),
  });

  // 🧩 Fetch Templates
  const getAllTemplates = async () => {
    try {
      setLoader(true)
      const res = await getTEMPLATES(currentPage, 10, sortBy, debouncedSearch);
      setTemplates(res?.data?.data?.templates || []);
      setTotalItems(res?.data?.data.count);

    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoader(false)
    }
  };

  useEffect(() => {
    getAllTemplates();

  }, [currentPage, debouncedSearch, sortBy]);


  useEffect(() => {
    setCurrentPage(0);
    getAllTemplates();

  }, [debouncedSearch, sortBy]);
  const debouncedHandler = useMemo(
    () =>
      debounce((value) => {
        // 🔥 hit API only if 3+ chars OR empty (for reset)
        if (value.length >= 1 || value.length === 0) {
          setDebouncedSearch(value);
          setCurrentPage(0); // reset pagination
        }
      }, 800),
    []
  );

  useEffect(() => {
    return () => {
      debouncedHandler.cancel();
    };
  }, []);


  // 🧩 Open Modal (for Add or Edit)
  const openModal = (template = null) => {

    setPreviewImage(template?.backgroundImage)
    setSelectedTemplate(template);
    setShowModal(true);
  };



  // 🧩 Handle Add or Update
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedKeys = values.editableKeys
        .filter(
          (item) =>
            item.key?.trim() !== "" &&
            item.value?.trim() !== "" &&
            item.maxLength !== "" &&
            item.maxLength !== null
        )
        .map((item) => ({
          [item.key.trim()]: item.value.trim(), // ✅ dynamic key
          maxLength: Number(item.maxLength),
        }));


      const payload = {
        ...values,
        editableKeys: formattedKeys,
      };

      if (selectedTemplate) {
        await updateTEMPLATES({
          ...payload,
          templateId: selectedTemplate._id,
        });
        toast.success("Template updated successfully");
      } else {
        await addTEMPLATES(payload);
        toast.success("Template added successfully");
      }

      resetForm();

      setShowModal(false);
      getAllTemplates()
    } catch (error) {
      toast.error("Error saving template");
    } finally {
      setSubmitting(false);
    }
  };


  // 🧩 Delete Template
  const handleDelete = async () => {
    try {
      setDeleting(true);
      await deleteTEMPLATES(deleteId);
      toast.success("Deleted successfully");
      setShowDeleteModal(false);
      setDeleteId(null);
      getAllTemplates();
    } catch (error) {
      toast.error("Error deleting template");
    } finally {
      setDeleting(false);
    }
  };
  const totalPages = Math.ceil(totalItems / itemsPerPage);





  const handleImageUpload = async (e, setFieldValue) => {
    const files = e.target.files[0];
    console.log("sssss", files)
    if (!files) return;

    try {


      setUploading(true);

      const key = `uploads/${Date.now()}_${files.name}`;
      const fileUrl = await uploadFileToS3(files, key);

      if (fileUrl) {

        setPreviewImage(fileUrl)
        setFieldValue("backgroundImage", fileUrl);
        toast.success("Images uploaded successfully!");
      }
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );


  // 🧩 Initial Values (Add or Edit)
  const initialValues = selectedTemplate
    ? {
      templateId: selectedTemplate._id,
      event: selectedTemplate.event?.name.toLowerCase() || "",
      html: selectedTemplate.htmlCode || "",
      name: selectedTemplate.name || "",
      // backgroundImage:selectedTemplate?.backgroundImage || "",
      editableKeys: selectedTemplate.editableKeys?.map((obj) => {
        const key = Object.keys(obj)[0];
        return { key, value: obj[key], maxLength: obj.maxLength || "", };
      }) || [{ key: "", value: "", maxLength: "" }],
    }
    : {
      event: "",
      name: "",
      html: "",
      editableKeys: [{ key: "", value: "", maxLength: "" }],
    };
  const formatEventName = (name = "") =>
    name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

  return (
    <div className="qx-page">
      <PageTitle
        pageTitle="Templates"
        subtitle="Manage invitation templates by event type"
        actions={
          <Button type="button" className="btn-primary qx-btn-brand" onClick={() => openModal(null)}>
            + Add New
          </Button>
        }
      />

      <Card className="qx-filter-card border-0 shadow-none mb-4">
        <Row className="g-3 qx-filter-grid align-items-end">
          <Col lg={4} md={6} sm={12}>
            <Form.Group className="mb-0">
              <Form.Label>Search</Form.Label>
              <div className="qx-search-wrap">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by template name..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    debouncedHandler(e.target.value);
                  }}
                />
                {search && (
                  <button
                    type="button"
                    onClick={() => {
                      setSearch("");
                      debouncedHandler("");
                    }}
                    className="qx-search-clear"
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group className="mb-0">
              <Form.Label>Event Types</Form.Label>
              <Form.Select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option value="">All Event Types</option>
                <option value="custom">Custom</option>
                <option value="0">Roka</option>
                <option value="1">Engagement</option>
                <option value="2">Haldi</option>
                <option value="4">Sangeet</option>
                <option value="5">Cocktail</option>
                <option value="6">Wedding</option>
                <option value="7">Music Bash</option>
                <option value="3">Mehndi</option>
                <option value="8">Reception</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Card>

      {loader ? (
        <PageContentLoader message="Loading templates..." />
      ) : templates.length > 0 ? (
        <Row className="qx-template-grid">
          {templates.map((item) => (
            <Col key={item._id} xl={3} lg={4} md={6} sm={12}>
              <Card className="qx-template-card">
                <Dropdown className="qx-template-card-menu">
                  <Dropdown.Toggle variant="" className="light sharp btn i-false">
                    {svg1}
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => openModal(item)}>Edit</Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setDeleteId(item._id);
                        setShowDeleteModal(true);
                      }}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Card.Img
                  onClick={() => {
                    setPreviewImg(
                      `https://managemyshaadib.s3.ap-south-1.amazonaws.com/${item.thumbnail}`,
                    );
                    setShowPreview(true);
                  }}
                  variant="top"
                  src={
                    `https://managemyshaadib.s3.ap-south-1.amazonaws.com/${item?.thumbnail}` ||
                    "https://via.placeholder.com/300x180"
                  }
                  alt={item?.name || "Template preview"}
                />

                <Card.Body>
                  {item?.name ? (
                    <div className="qx-template-meta-row">
                      <span className="qx-template-meta-label">Template Name</span>
                      <span className="qx-template-meta-value">{item.name}</span>
                    </div>
                  ) : null}

                  <div className="qx-template-meta-row">
                    <span className="qx-template-meta-label">Event Name</span>
                    <span className="qx-template-meta-value">
                      {formatEventName(item?.event?.name || "")}
                    </span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="qx-empty-state">
          <p className="mb-1" style={{ fontWeight: 500, color: "#27272a" }}>No templates found</p>
          <p className="mb-0">Try adjusting your search or add a new template.</p>
        </div>
      )}

      {templates.length > 0 && totalPages > 0 && (
        <div className="qx-pagination-only-card">
          <Pagination
            pageCount={totalPages}
            pageValue={currentPage}
            setPage={setCurrentPage}
            total={totalItems}
            pageSize={itemsPerPage}
            itemLabel="templates"
          />
        </div>
      )}

      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="qx-modal"
        dialogClassName="qx-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedTemplate ? "Edit Template" : "Add Template"}</Modal.Title>
        </Modal.Header>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <FormikForm>
              <Modal.Body>
                {/* Event Dropdown */}
                <Form.Group className="mb-3">
                  <Form.Label>Template Name</Form.Label>
                  <Field name="name" className="form-control" />
                  <div className="text-danger">
                    <ErrorMessage name="name" />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Event</Form.Label>
                  <Field as="select" name="event" className="form-control">
                    <option value="custom">Custom</option>
                    <option value="roka">Roka</option>
                    <option value="engagement">Engagement</option>
                    <option value="haldi">Haldi</option>
                    <option value="sangeet">Sangeet</option>
                    <option value="cocktail">Cocktail</option>
                    <option value="wedding">Wedding</option>
                    <option value="musicbash">Music Bash</option>
                    <option value="mehndi">Mehndi</option>
                    <option value="reception">Reception</option>




                    {/* <option value="custom">Custom</option>
              <option value="0">Roka</option>
                  <option value="1">Engagement</option>
              <option value="2">Haldi</option>
              <option value="4">Sangeet</option>
              <option value="5">Cocktail</option>
              <option value="6">Wedding</option>
              <option value="7">Music Bash</option>
              <option value="3">Mehndi</option>
              <option value="8">Reception</option> */}
                  </Field>
                  <div className="text-danger">
                    <ErrorMessage name="event" />
                  </div>
                </Form.Group>

                {/* HTML Field */}
                <Form.Group className="mb-3">
                  <Form.Label>HTML CODE</Form.Label>
                  <Field as="textarea" name="html" rows={6} className="form-control" />
                  <div className="text-danger">
                    <ErrorMessage name="html" />
                  </div>
                </Form.Group>




                {/* <Form.Group className="mb-3">
          <Form.Label>BackGround Image</Form.Label>
      
          {uploading && <Spinner animation="border" size="sm" className="ms-2" />}
          
    <div className="mt-3">
     {previewImage && (
      <img
        src={previewImage}
        alt="Preview"
        style={{
          width: "150px",
          height: "100px",
          objectFit: "cover",
          borderRadius: "6px",
          border: "2px solid #A60000",
          marginBottom: "10px",
        }}
      />
    )}
          <Form.Control
            type="file"
    
            accept="image/*"
            onChange={(e)=>handleImageUpload(e,setFieldValue)}
          />
            </div>
        
        </Form.Group> */}

                {/* Editable Keys */}
                <FieldArray name="editableKeys">
                  {({ push, remove }) => (
                    <div className="mb-3">
                      <Form.Label>Editable Keys</Form.Label>

                      {values.editableKeys.map((item, index) => (
                        <Row key={index} className="align-items-start mb-2 g-2">
                          <Col xs={12} md={3}>
                            <Field
                              name={`editableKeys.${index}.key`}
                              className="form-control"
                              placeholder="Enter key"
                            />
                            <ErrorMessage
                              name={`editableKeys.${index}.key`}
                              component="div"
                              className="text-danger"
                            />
                          </Col>

                          <Col xs={12} md={3}>
                            <Field
                              name={`editableKeys.${index}.value`}
                              className="form-control"
                              placeholder="Enter value"
                            />
                            <ErrorMessage
                              name={`editableKeys.${index}.value`}
                              component="div"
                              className="text-danger"
                            />
                          </Col>

                          <Col xs={12} sm={6} md={3}>
                            <Field
                              type="number"
                              name={`editableKeys.${index}.maxLength`}
                              className="form-control"
                              placeholder="Max length"
                            />
                            <ErrorMessage
                              name={`editableKeys.${index}.maxLength`}
                              component="div"
                              className="text-danger"
                            />
                          </Col>

                          {/* DELETE BUTTON */}
                          <Col xs={12} sm={6} md={1} className="d-flex align-items-center">
                            {values.editableKeys.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm w-100"
                                onClick={() => remove(index)}
                              >
                                X
                              </button>
                            )}
                          </Col>

                        </Row>
                      ))}

                      <button
                        type="button"
                        className="btn btn-secondary btn-sm mt-2"
                        onClick={() => push({ key: "", value: "", maxLength: "" })}
                      >
                        + Add Key
                      </button>
                    </div>
                  )}
                </FieldArray>

              </Modal.Body>

              <Modal.Footer>
                <Button type="button" variant="outline-secondary" className="btn-cancel" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button type="submit" className="btn-submit" disabled={isSubmitting || uploading}>
                  {isSubmitting
                    ? selectedTemplate
                      ? "Saving..."
                      : "Adding..."
                    : selectedTemplate
                      ? "Save Changes"
                      : "Add Template"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>


      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        centered
        className="qx-template-preview-modal"
        dialogClassName="custom-modal-width"
      >
        <Modal.Body>
          <button
            type="button"
            onClick={() => setShowPreview(false)}
            className="qx-template-preview-close btn-close"
            aria-label="Close"
          />
          <img src={previewImg} alt="Template preview" className="qx-template-preview-img" />
        </Modal.Body>
      </Modal>


      <ConfirmDeleteModal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeleteId(null);
        }}
        onConfirm={handleDelete}
        loading={deleting}
        title="Delete Template"
        message="Are you sure you want to delete this template? This action cannot be undone."
      />
    </div>
  );
};

export default Template;
